import { jsx as r } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { MaskBase as f } from "../../MaskInput/MaskBase.mjs";
const n = d((a, e) => {
  const { "data-testid": t, id: i, name: m, timeInfo: s, ...o } = a;
  return /* @__PURE__ */ r(
    f,
    {
      ref: e,
      name: `${m}-input`,
      id: i,
      "data-testid": t ? `${t}-input` : void 0,
      format: "##:##",
      mask: ["H", "H", "M", "M"],
      value: s.timeField,
      ...o
    }
  );
});
n.displayName = "TimeMask";
export {
  n as default
};
